import React, { useEffect, useRef } from "react";
import wizard_css from "../../inspection.module.css";

export default function CheckText({ check, topLevel, index, setCheckValue }) {
  const input = useRef();

  useEffect(() => {
    const jInput = window.$(input.current);
    if (check.metadata && check.metadata.properties) {
      for (const prop of Object.keys(check.metadata.properties)) {
        jInput.prop(prop, check.metadata.properties[prop]);
      }
    }
    if (jInput.hasClass("jf-format-number")) {
      jInput.number(true, 0);
    }
  }, [check.metadata]);

  return (
    <>
      <div>
        {!!check.critical && (
          <small className="bg-danger">
            This value puts equipment out of service!
          </small>
        )}
      </div>
      <label className={wizard_css["text"]}>
        <span>{check.title}</span>{" "}
        <input
          ref={(ref) => (input.current = ref)}
          readOnly={check.locked || check.disabled}
          onChange={(event) =>
            setCheckValue(event.target.value, check.id, topLevel)
          }
          value={check.value || ""}
          className={check.metadata?.class}
        />
      </label>
      {"" + check.closedItemComment !== "" && (
        <span className={wizard_css["corrective-action"]}>
          Corrective Action:
          <i>{check.closedItemComment}</i>
          {"" + check.closedItemPhoto !== "" && (
            <a href={check.closedItemPhoto} data-lightbox={check.title}>
              view image
            </a>
          )}
        </span>
      )}
      {!!check.status && (
        <span style={{ color: "black" }}>
          Status:
          <i>{check.status}</i>
        </span>
      )}
    </>
  );
}
